export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6199.286cb76c.jpg";